import TmrBaseResource from './TmrBaseResource'

export default class Zones extends TmrBaseResource {
  static endpoint = '/zones'
}
